import {DateTime} from 'luxon';
import {createTransform} from 'redux-persist';
import {CartState} from '../Cart/state';

export const deliveryDateTransformer = createTransform(
  null,
  (outboundState: CartState) => ({...outboundState, deliveryDate: DateTime.fromISO(outboundState.deliveryDate as unknown as string)}),
  {whitelist: ['cart']},
);
